import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ProductList extends Component{
    render(){
        const { themeLayoutId } = this.props
        return(
            <React.Fragment>

                {/* Pet Theme Start */}

                {themeLayoutId === 'L04' &&
                <section className="pt-0 banner-6 ratio2_1">
                    <div className="container">
                        <div className="row partition3">
                            <div className="col-md-4">
                                <Link to="/">
                                    <div className="collection-banner p-left">
                                    <div className="img-part">
                                        <img src="https://react.pixelstrap.com/multikart/assets/images/pets/banner/1.jpg" className="img-fluid blur-up lazyload bg-img" alt="" />
                                    </div>
                                    <div className="contain-banner banner-3">
                                        <div>
                                            <h2>Clothes</h2>
                                        </div>
                                    </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-4">
                                <Link to="/">
                                    <div className="collection-banner p-left">
                                    <div className="img-part">
                                        <img src="https://react.pixelstrap.com/multikart/assets/images/pets/banner/3.jpg" className="img-fluid blur-up lazyload bg-img" alt="" />
                                    </div>
                                    <div className="contain-banner banner-3">
                                        <div>
                                            <h2>Cats</h2>
                                        </div>
                                    </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-4">
                                <Link to="/">
                                    <div className="collection-banner p-left">
                                    <div className="img-part">
                                        <img src="https://react.pixelstrap.com/multikart/assets/images/pets/banner/6.jpg" className="img-fluid blur-up lazyload bg-img" alt="" />
                                    </div>
                                    <div className="contain-banner banner-3">
                                        <div>
                                            <h2>Bowls</h2>
                                        </div>
                                    </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
             }

             {/* End Pet Theme */}
            </React.Fragment>
        )
    }
}

export default ProductList;